<menu-banner [projectName]="folderName">
  <!-- <mat-icon>folder_open</mat-icon> -->
  {{folderName}}
  <span onTheRight>
    <span matTooltip="Export codelists of the selected mappings (no mappings without revisions, they have to be saved before)">
      <button (click)="mappings.openDownloadDialog(mappings.selectedFilteredMappings)" [disabled]="!mappings || !mappings.canDownload()" mat-icon-button>
        <mat-icon>download</mat-icon>
      </button>
    </span>
  </span>
</menu-banner>

<div class="spaced center-content">
  <mat-tab-group>
    <mat-tab label="Mappings">
      <folder-mappings *ngIf="user && role" [user]="user" [role]="role"></folder-mappings>
    </mat-tab>
    <mat-tab label="Members (you are {{(role ?? 'not member').toLowerCase()}})">
      <folder-users *ngIf="folderName && user && (user.admin || role)" [folderName]="folderName" [user]="user" [role]="role"></folder-users>
    </mat-tab>
  </mat-tab-group>
</div>